module.exports = __webpack_public_path__ + "img/warning.bf696f8a.png";